"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prometheusEditorInitialState = exports.prometheusStateTransitionMap = exports.updatePrometheusEditorState = exports.PrometheusEditorStateHelper = void 0;
var prometheusStateTransitionMap = {
    EMPTY_STATE: {
        INIT_DATASET: 'DATASET_LOADING_STATE',
    },
    DATASET_LOADING_STATE: {
        LOADING_DATASET_SUCCEEDED: 'DATASET_READY_STATE',
        LOADING_DATASET_FAILED: 'DATASET_ERROR_STATE',
    },
    DATASET_ERROR_STATE: {
        RELOADING_DATASET: 'DATASET_LOADING_STATE',
    },
    DATASET_READY_STATE: {
        LOADING_OBJECTIVE_SUCCEEDED: 'DEFINE_OBJECTIVE_READY_STATE',
        LOADING_OBJECTIVE_FAILED: 'DEFINE_OBJECTIVE_ERROR_STATE',
    },
    DEFINE_OBJECTIVE_READY_STATE: {
        LOADING_OBJECTIVE_SUCCEEDED: 'DEFINE_OBJECTIVE_READY_STATE',
        LOADING_OBJECTIVE_FAILED: 'DEFINE_OBJECTIVE_ERROR_STATE',
        TRAINING_READY: 'MODEL_TRAINING_READY_STATE',
    },
    DEFINE_OBJECTIVE_ERROR_STATE: {
        LOADING_OBJECTIVE_SUCCEEDED: 'DEFINE_OBJECTIVE_READY_STATE',
        LOADING_OBJECTIVE_FAILED: 'DEFINE_OBJECTIVE_ERROR_STATE',
    },
    MODEL_TRAINING_READY_STATE: {
        TRAINING_MODEL: 'MODEL_TRAINING_STATE',
    },
    MODEL_TRAINING_STATE: {
        LOADING_MODEL_RESULT: 'MODEL_RESULT_LOADING_STATE',
        TRAINING_MODEL_FAILED: 'MODEL_TRAINING_ERROR_STATE',
    },
    MODEL_TRAINING_ERROR_STATE: {
        TRAINING_MODEL: 'MODEL_TRAINING_STATE',
    },
    MODEL_RESULT_LOADING_STATE: {
        LOADING_MODEL_RESULT_SUCCEEDED: 'UNDEPLOYED_MODEL_RESULT_READY_STATE',
        LOADING_MODEL_RESULT_FAILED: 'MODEL_RESULT_ERROR_STATE',
    },
    MODEL_RESULT_ERROR_STATE: {
        LOADING_MODEL_RESULT: 'MODEL_RESULT_LOADING_STATE',
    },
    UNDEPLOYED_MODEL_RESULT_READY_STATE: {
        DEPLOYING_MODEL: 'MODEL_DEPLOYING_STATE',
    },
    MODEL_DEPLOYING_STATE: {
        DEPLOYING_MODEL_SUCCEEDED: 'DEPLOYED_MODEL_RESULT_READY_STATE',
        DEPLOYING_MODEL_FAILED: 'MODEL_DEPLOYED_ERROR_STATE',
    },
    MODEL_DEPLOYED_ERROR_STATE: {
        DEPLOYING_MODEL: 'MODEL_DEPLOYING_STATE',
    },
    DEPLOYED_MODEL_RESULT_READY_STATE: {
        UNDEPLOYING_MODEL: 'MODEL_UNDEPLOYING_STATE',
    },
    MODEL_UNDEPLOYING_STATE: {
        UNDEPLOYING_MODEL_SUCCEEDED: 'UNDEPLOYED_MODEL_RESULT_READY_STATE',
        UNDEPLOYING_MODEL_FAILED: 'MODEL_UNDEPLOYED_ERROR_STATE',
    },
    MODEL_UNDEPLOYED_ERROR_STATE: {
        UNDEPLOYING_MODEL: 'MODEL_UNDEPLOYING_STATE',
    },
};
exports.prometheusStateTransitionMap = prometheusStateTransitionMap;
/**
 * The function defines all possible state transition within the Editor application
 * @param previousState the previous state application is on
 * @param action the dispatched action
 * @returns next application state
 */
var stateReducer = function (previousState, action) {
    var nextStateType = prometheusStateTransitionMap[previousState.type][action.type];
    if (!nextStateType) {
        throw new Error("STATE TRANSITION IS NOT DEFINED FOR STATE[".concat(previousState.type, "] WITH ACTION[").concat(action.type, "]"));
    }
    console.log("[STATE MANAGER] Transition from ".concat(previousState.type, " to ").concat(nextStateType, ". [").concat(action.type, "]"));
    return __assign(__assign({}, action), { type: nextStateType });
};
var prometheusEditorInitialState = {
    previousState: undefined,
    currentState: { type: 'EMPTY_STATE' },
};
exports.prometheusEditorInitialState = prometheusEditorInitialState;
var updatePrometheusEditorState = function (state, action) {
    state.previousState = state.currentState;
    state.currentState = stateReducer(state.previousState, action);
};
exports.updatePrometheusEditorState = updatePrometheusEditorState;
var PrometheusEditorStateHelper = /** @class */ (function () {
    function PrometheusEditorStateHelper() {
    }
    PrometheusEditorStateHelper.isModelReadyToTrain = function (state) {
        switch (state.type) {
            case 'MODEL_TRAINING_READY_STATE':
            case 'MODEL_TRAINING_ERROR_STATE':
                return true;
        }
        return false;
    };
    PrometheusEditorStateHelper.isModelTraining = function (state) {
        return state.type === 'MODEL_TRAINING_STATE';
    };
    PrometheusEditorStateHelper.isModelTrained = function (state) {
        switch (state.type) {
            case 'MODEL_RESULT_LOADING_STATE':
            case 'UNDEPLOYED_MODEL_RESULT_READY_STATE':
            case 'DEPLOYED_MODEL_RESULT_READY_STATE':
            case 'MODEL_RESULT_ERROR_STATE':
            case 'MODEL_UNDEPLOYING_STATE':
            case 'MODEL_DEPLOYING_STATE':
            case 'MODEL_DEPLOYED_ERROR_STATE':
            case 'MODEL_UNDEPLOYED_ERROR_STATE':
                return true;
        }
        return false;
    };
    PrometheusEditorStateHelper.isModelDeployed = function (state) {
        return state.type === 'DEPLOYED_MODEL_RESULT_READY_STATE';
    };
    // Functions to decide header enabled/disabled status, next step button
    PrometheusEditorStateHelper.defineObjectiveSubspaceDisabled = function (state) {
        switch (state.type) {
            case 'EMPTY_STATE':
            case 'DATASET_LOADING_STATE':
            case 'DEFINE_OBJECTIVE_ERROR_STATE':
                return true;
        }
        return false;
    };
    PrometheusEditorStateHelper.trainSubspaceDisabled = function (state) {
        switch (state.type) {
            case 'EMPTY_STATE':
            case 'DATASET_LOADING_STATE':
            case 'DATASET_ERROR_STATE':
            case 'DATASET_READY_STATE':
            case 'DEFINE_OBJECTIVE_READY_STATE':
            case 'DEFINE_OBJECTIVE_ERROR_STATE':
                return true;
        }
        return false;
    };
    PrometheusEditorStateHelper.resultSubspaceDisabled = function (state) {
        return !PrometheusEditorStateHelper.isModelTrained(state);
    };
    PrometheusEditorStateHelper.deploySubspaceDisabled = function (state) {
        // TODO: If deploy enable status differs from model result, append the condition
        return !PrometheusEditorStateHelper.isModelTrained(state);
    };
    return PrometheusEditorStateHelper;
}());
exports.PrometheusEditorStateHelper = PrometheusEditorStateHelper;
//# sourceMappingURL=EditorStateManager.js.map